module.exports = __webpack_public_path__ + "img/report9.ee7257d5.jpg";